export default "__VITE_ASSET__1606de5e__"